<h3 mat-dialog-title>Trail Setup</h3>

<mat-dialog-content>
<form name="myForm" class="example-form">
    <mat-form-field class="example-full-width">
        <mat-label>System Setup</mat-label>
        <textarea matInput type="text" name="system_setup" [(ngModel)]="trailSetup.system_setup"></textarea>
    </mat-form-field>

    <mat-form-field class="example-full-width">
        <mat-label>Remark</mat-label>
        <textarea matInput type="text" name="remark" [(ngModel)]="trailSetup.remark"></textarea>
    </mat-form-field>

    <mat-form-field class="example-full-width" >
        <mat-label>Confirmed?</mat-label>
        <mat-select name="confirmed" [(ngModel)]="selectedState">
            @for (confiremState of confirmedStates; track confiremState) {
            <mat-option [value]="confiremState">{{confiremState.expression}}</mat-option>
            }
        </mat-select>
    </mat-form-field>

</form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="trailSetup" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>
